// extracted by mini-css-extract-plugin
export default {"hilighted":"Row_hilighted__8nPtM","zero":"Row_zero__tcs9g","placeHolderShimmer":"Row_placeHolderShimmer__SNxQo"};